var map = {
	"./assets_utils": "a6a2",
	"./assets_utils.js": "a6a2",
	"./fonts/BrandingSF-Black.ttf": "96a9",
	"./fonts/BrandingSF-Medium.ttf": "4a0a",
	"./fonts/CaviarDreams_Bold.ttf": "2ff0",
	"./fonts/Montserrat-Light.ttf": "5b51",
	"./fonts/Montserrat-SemiBold.ttf": "44b3",
	"./fonts/Poppins-Bold.ttf": "0c3c",
	"./fonts/Poppins-Medium.ttf": "4962",
	"./fonts/Poppins-Regular.ttf": "e9f5",
	"./icons/agricultura.svg": "dbfd",
	"./icons/educacion.svg": "7d2d",
	"./icons/identidad.svg": "4cb3",
	"./icons/pagos.svg": "ab18",
	"./icons/tramite.svg": "5e64",
	"./img/1-icono-nuevo-selected.svg": "7e61",
	"./img/1-icono-nuevo-tramite-selected.svg": "6d5e",
	"./img/1-icono-nuevo-tramite.svg": "7c84",
	"./img/1-icono-nuevo.svg": "b58d",
	"./img/1.png": "775a",
	"./img/1.svg": "d561",
	"./img/10-estatus-enproceso.svg": "7723",
	"./img/10.png": "4abd",
	"./img/10.svg": "7feb",
	"./img/11-estatus-vermas.svg": "5c33",
	"./img/11.png": "e509",
	"./img/11.svg": "a53e",
	"./img/12.svg": "1127",
	"./img/13.svg": "63c1",
	"./img/2-icono-mistramites-selected.svg": "79eb",
	"./img/2-icono-mistramites.svg": "5dca",
	"./img/2-iconomis-tramites-selected.svg": "7591",
	"./img/2-iconomis-tramites.svg": "9f1e",
	"./img/2.png": "8e30",
	"./img/2.svg": "4eac",
	"./img/3-icono-pendientes-selected.svg": "7145",
	"./img/3-icono-pendientes.svg": "d25f",
	"./img/3.png": "1f66",
	"./img/3.svg": "f464",
	"./img/4-icono-enproceso-selected.svg": "98d5",
	"./img/4-icono-enproceso.svg": "be25",
	"./img/4.png": "5fa5",
	"./img/4.svg": "2e89",
	"./img/5-icono-cancelado-selecteds.svg": "7d2c",
	"./img/5-icono-cancelados-selected.svg": "3523",
	"./img/5-icono-cancelados.svg": "15e2",
	"./img/5.png": "c037",
	"./img/5.svg": "3d87",
	"./img/6-icono-completados-selected.svg": "2b43",
	"./img/6-icono-completados.svg": "4ae9",
	"./img/6.png": "338d",
	"./img/6.svg": "82f2",
	"./img/7-icono-mis-ordenes-selected.svg": "25bd",
	"./img/7-icono-mis-ordenes.svg": "e068",
	"./img/7-icono-misordenes-selected.svg": "2a59",
	"./img/7-icono-misordenes.svg": "3243",
	"./img/7.png": "0f01",
	"./img/7.svg": "d52d",
	"./img/7eleven.png": "ff7b",
	"./img/8-estatus-pendiente.svg": "409e",
	"./img/8.png": "eadf",
	"./img/8.svg": "896a",
	"./img/9-estatus-completado.svg": "a392",
	"./img/9.png": "6846",
	"./img/BBVA.png": "a6fc",
	"./img/Citibanamex.png": "bcd6",
	"./img/E.Firma-08.svg": "5b56",
	"./img/E.Firma-12.svg": "a0d3",
	"./img/Foto copia.png": "2571",
	"./img/GOBIERNO_NL_LOGO-02.png": "154d",
	"./img/Oxxo_Logo.svg": "193e",
	"./img/SPEI.png": "b77e",
	"./img/aviso_de_privacidad.png": "f274",
	"./img/aviso_de_privacidad.webp": "7e05",
	"./img/banamex.svg": "b80f",
	"./img/beneficios-04.png": "59a6",
	"./img/buscar.png": "28ab",
	"./img/campana.svg": "4156",
	"./img/cancelado_a.png": "8a3d",
	"./img/cancelado_b.png": "f132",
	"./img/cancelado_c.png": "cc39",
	"./img/carrito.png": "984a",
	"./img/cel-web.png": "0d09",
	"./img/cel-web.webp": "31cc",
	"./img/cel.png": "236f",
	"./img/cel.svg": "c386",
	"./img/celular-05.png": "8277",
	"./img/cfdi40.png": "d507",
	"./img/chicos-movil.png": "cd37",
	"./img/chicos-web.png": "2984",
	"./img/chicos-web.webp": "57e5",
	"./img/completado_a.png": "0c29",
	"./img/completado_b.png": "1b09",
	"./img/completado_c.png": "58c4",
	"./img/compu-colores-new.png": "68ce",
	"./img/compu-colores-new.webp": "e440",
	"./img/compu.svg": "1bc1",
	"./img/continuar.png": "6213",
	"./img/corchete-azul-11.svg": "8d39",
	"./img/corchete-bienvenido.svg": "fb4d",
	"./img/corchete-fondo-crema-13.svg": "b8f6",
	"./img/corchete-fondo.svg": "ee10",
	"./img/corchete-header-02.png": "cead",
	"./img/corchete-header-02.webp": "0cc3",
	"./img/eliminar-test.png": "7963",
	"./img/escudo-nl2.svg": "ca36",
	"./img/escudo-nl2.webp": "a7bd",
	"./img/fondo_login.png": "759b",
	"./img/i_facebook.png": "1595",
	"./img/i_facebook.webp": "7d1b",
	"./img/i_facebook_a.png": "4524",
	"./img/i_facebook_a.webp": "c2c9",
	"./img/i_instagram.png": "8512",
	"./img/i_instagram.webp": "f016",
	"./img/i_instagram_a.png": "8890",
	"./img/i_instagram_a.webp": "03d1",
	"./img/i_telegram2.png": "7098",
	"./img/i_telegram2.webp": "1a2a",
	"./img/i_telegram2_a.png": "0832",
	"./img/i_telegram2_a.webp": "5ac5",
	"./img/i_twitter.png": "c5d4",
	"./img/i_twitter.webp": "3845",
	"./img/i_twitter_a.png": "730f",
	"./img/i_twitter_a.webp": "1649",
	"./img/i_whatsapp.png": "f101",
	"./img/i_whatsapp.webp": "87bf",
	"./img/i_whatsapp_a.png": "e766",
	"./img/i_whatsapp_a.webp": "5308",
	"./img/i_youtube.png": "499e",
	"./img/i_youtube.webp": "ce0d",
	"./img/i_youtube_a.png": "b312",
	"./img/i_youtube_a.webp": "dce4",
	"./img/iconos-categorias-02.svg": "83c8",
	"./img/iconos-categorias-03.svg": "c52f",
	"./img/iconos-categorias-04.svg": "879c",
	"./img/iconos-categorias-05.svg": "4f86",
	"./img/iconos-ilustracion-06.jpg": "56af",
	"./img/iconos-ilustracion-07.jpg": "28e2",
	"./img/iconos-ilustracion-08.jpg": "0ca9",
	"./img/imagen-chicos.png": "686a",
	"./img/jovenes-03.png": "d610",
	"./img/jovenes-comprimido-03.png": "8aa6",
	"./img/leon1.png": "c4c3",
	"./img/leon1.webp": "c4cc",
	"./img/logo-_1.svg": "ab7a",
	"./img/logo-_2.svg": "fa45",
	"./img/logo-genl.svg": "d266",
	"./img/logo-genl.webp": "75e4",
	"./img/logo_bestgob.png": "f234",
	"./img/logo_circular_bco.png": "06f5",
	"./img/logo_estado.svg": "7782",
	"./img/logo_genl.png": "40ab",
	"./img/logo_genl_blanco.png": "3b10",
	"./img/logo_nl.png": "df08",
	"./img/lupa.svg": "d697",
	"./img/maletin-default.png": "73eb",
	"./img/maletin-default.webp": "68d7",
	"./img/maletin.svg": "4f6b",
	"./img/menu-burger.svg": "5ddf",
	"./img/menu.png": "7738",
	"./img/movil.png": "c25c",
	"./img/movil.webp": "baea",
	"./img/nuevo_a.png": "9e53",
	"./img/nuevo_b.png": "e35b",
	"./img/ordenes_a.png": "54a8",
	"./img/ordenes_b.png": "bc94",
	"./img/pendiente_a.png": "67a9",
	"./img/pendiente_b.png": "57fb",
	"./img/pendiente_c.png": "1104",
	"./img/proceso_a.png": "4e53",
	"./img/proceso_b.png": "6747",
	"./img/proceso_c.png": "3698",
	"./img/progreso.png": "5666",
	"./img/reloj.svg": "f049",
	"./img/scotiabank.png": "6bb8",
	"./img/status-canceled.svg": "e90c",
	"./img/telecom.svg": "3f09",
	"./img/terminos_y_condiciones-02.png": "a604",
	"./img/terminos_y_condiciones-02.webp": "7b98",
	"./img/todo_a.png": "ee36",
	"./img/todo_b.png": "96ec",
	"./img/tramite.jpg": "8979",
	"./img/tramites-colores.png": "5433",
	"./img/tramites-colores.webp": "0d56",
	"./img/visa-mc.png": "720f",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./themes/bestgob": "3272",
	"./themes/bestgob.js": "3272",
	"./themes/tamaulipas": "316e",
	"./themes/tamaulipas.js": "316e",
	"./themes/theme": "9565",
	"./themes/theme.js": "9565"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";